import React, { useEffect, useState } from "react";
import productService from "../../../../../services/productService";
import SearchBar from "../../../../../components/SearchBar";
import GeneralIcon from "../../../../../assets";

export default function AdicionarProdutoFinalStep({
  product,       // <- Product being edited (optional)
  variants,
  onFinish,
  onBack,
}) {
  const [defaultVariant, setDefaultVariant] = useState(
    product?.defaultVariantIndex ?? 0
  );
  const [documents, setDocuments] = useState([]);
  const [linkedDocs, setLinkedDocs] = useState(product?.linkedDocuments || []);
  const [searchTerm, setSearchTerm] = useState("");
  const [page, setPage] = useState(1);

  // 🔍 Carrega documentos da API
  useEffect(() => {
    productService.fetchDocuments(page).then((res) => {
      setDocuments(res || []);
    });
  }, [page]);

  // 🔍 Busca de documentos
  async function handleSearch() {
    const res = await productService.searchDocuments(searchTerm);
    setDocuments(res || []);
  }

  // ➕ Vincular documento
  function applyDocument(doc) {
    if (!linkedDocs.some((d) => d.id === doc.id)) {
      setLinkedDocs((prev) => [...prev, doc]);
    }
  }

  // ❌ Remover documento vinculado
  function removeDocument(id) {
    setLinkedDocs((prev) => prev.filter((d) => d.id !== id));
  }

  return (
    <div className="space-y-6">

      {/* Seletor variante padrão */}
      <div>
        <label className="font-medium">Definir variante padrão*</label>
        <select
          className="w-full bg-gray-50 border rounded px-3 py-2 mt-1"
          value={defaultVariant}
          onChange={(e) => setDefaultVariant(e.target.value)}
        >
          <option value="">Selecione...</option>
          {variants.map((v, i) => (
            <option key={i} value={i}>
              {v.name}
            </option>
          ))}
        </select>
      </div>

      {/* Vincular documentos */}
      <div>
        <label className="font-medium">Vincular documentos</label>

        <div className="flex gap-2 mt-2">
          <SearchBar
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            placeholder="Pesquisa por documentos"
            className="flex-1"
          />
          <button
            onClick={handleSearch}
            className="p-2 bg-purple-600 text-white rounded"
          >
            <GeneralIcon iconName="search" className="w-5 h-5" />
          </button>
        </div>

        {/* Lista de resultados */}
        <div className="mt-4 space-y-2">
          {documents.map((doc) => (
            <div
              key={doc.id}
              className="flex justify-between items-center p-2 border rounded"
            >
              <span>{doc.name}</span>
              <button
                onClick={() => applyDocument(doc)}
                disabled={linkedDocs.some((d) => d.id === doc.id)}
                className="px-3 py-1 rounded text-sm 
                  bg-purple-100 text-purple-700 disabled:opacity-40"
              >
                Aplicar
              </button>
            </div>
          ))}
        </div>

        {/* Documentos vinculados */}
        <div className="mt-4 space-y-2">
          {linkedDocs.map((doc) => (
            <div
              key={doc.id}
              className="flex justify-between items-center p-2 bg-purple-50 rounded"
            >
              <span className="text-purple-900">{doc.name}</span>
              <button
                onClick={() => removeDocument(doc.id)}
                className="px-3 py-1 bg-red-100 text-red-700 rounded text-sm"
              >
                Remover
              </button>
            </div>
          ))}
        </div>
      </div>

      {/* Paginação */}
      <div className="flex justify-between text-sm mt-6">
        <button
          onClick={() => setPage((p) => Math.max(1, p - 1))}
          className="px-4 py-2 bg-purple-100 text-purple-800 rounded"
        >
          Anterior
        </button>

        <span>Página {page}</span>

        <button
          onClick={() => setPage((p) => p + 1)}
          className="px-4 py-2 bg-purple-100 text-purple-800 rounded"
        >
          Próximo
        </button>
      </div>

      {/* Finalizar */}
      <button
        onClick={() => onFinish(defaultVariant, linkedDocs)}
        className="w-full py-3 rounded bg-purple-600 text-white mt-4"
      >
        {product ? "Atualizar produto" : "Adicionar produto"}
      </button>
    </div>
  );
}
